import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/auth/mutationTypes';

export default {
  [types.SET_USER_POOL_ID]: createSetPropMutation('userPoolId'),
  [types.CLEAR_USER_POOL_ID]: createClearPropMutation('userPoolId', ''),
  [types.SET_LOGIN_DOMAIN]: createSetPropMutation('loginDomain'),
  [types.CLEAR_LOGIN_DOMAIN]: createClearPropMutation('loginDomain', ''),
  [types.SET_AUTH]: createSetPropMutation('auth'),
  [types.CLEAR_AUTH]: createClearPropMutation('auth'),
  [types.SET_CHALLENGE](state, { challengeName, challengeUser }) {
    state.challengeName = challengeName;
    state.challengeUser = challengeUser;
  },
  [types.CLEAR_CHALLENGE](state) {
    state.challengeName = null;
    state.challengeUser = null;
  },
  [types.SET_PROFILE]: createSetPropMutation('profile'),
  [types.SET_PERMISSIONS]: createSetPropMutation('permissions'),
  [types.SET_PREFILL_DATA]: createSetPropMutation('prefillData'),
  [types.CLEAR_PREFILL_DATA]: createClearPropMutation('prefillData', null),
};
